"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PageCover = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var _collage_ = _interopRequireDefault(require("../../../asset/collage_1.png"));

var _collage_2 = _interopRequireDefault(require("../../../asset/collage_2.png"));

var _collage_3 = _interopRequireDefault(require("../../../asset/collage_3.png"));

var _collage_4 = _interopRequireDefault(require("../../../asset/collage_4.png"));

var _collage_5 = _interopRequireDefault(require("../../../asset/collage_5.png"));

var _collage_6 = _interopRequireDefault(require("../../../asset/collage_6.png"));

var css = _interopRequireWildcard(require("./PageCover.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const VARIANT_COLOR_MAP = {
  1: 'gold',
  2: 'aqua',
  3: 'yellow',
  4: 'green',
  5: 'orange',
  6: 'brown'
};
const VARIANT_PORTRAITS_MAP = {
  1: _collage_.default,
  2: _collage_2.default,
  3: _collage_3.default,
  4: _collage_4.default,
  5: _collage_5.default,
  6: _collage_6.default
};

const PageCoverView = props => (0, _pragma.createFelaElement)(_.View, _extends({
  alignItems: "center",
  justifyContent: "space-between",
  flex: true,
  padding: ['none', 'none', 'none', 'xxxlarge']
}, props));
/**
 * PageCover is used for main page banner. Any additional content can be
 * rendered as children
 *
 * All HTML attributes are supported, and all unhandled props, including refs,
 * are forwarded to the root `PageCover` component.
 */


const PageCover = ({
  subTitle,
  title,
  variant = 1,
  ...otherProps
}) => (0, _pragma.createFelaElement)(_.Card, _extends({
  as: PageCoverView,
  color: VARIANT_COLOR_MAP[variant],
  css: css.root,
  rounded: false,
  variant: "secondary"
}, otherProps), (0, _pragma.createFelaElement)(_.View, {
  flex: true,
  flexDirection: "column",
  gap: "small",
  justifyContent: "center"
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "heading1",
  color: "text.3",
  children: title
}), (0, _pragma.createFelaElement)(_.Text, {
  children: subTitle,
  color: "text.3",
  variant: "heading3"
})), (0, _pragma.createFelaElement)("img", {
  alt: "",
  "aria-hidden": true,
  css: css.portrait,
  height: "auto",
  src: VARIANT_PORTRAITS_MAP[variant],
  width: 416
}));

exports.PageCover = PageCover;
PageCover.displayName = 'PageCover';
var _default = PageCover;
exports.default = _default;
//# sourceMappingURL=PageCover.js.map